export const dota_bg = require("./dota_background.png");
export const csgo_bg = require("./dota_background.png");
export const hs_bg = require("./dota_background.png");
export const ow_bg = require("./dota_background.png");
export const lol_bg = require("./dota_background.png");
export const cup_bg = require("./cup.png");



// WEBPACK FOOTER //
// ./src/assets/images/backgrounds/index.js